
class CreateFacilityTypeReq {
 
    constructor(){
        this.Id = undefined;
        this.TypeName = undefined;

        this.Description = undefined;
        this.Category = undefined
        this.pagingParams = {
            pageNumber : undefined,
            pageSize : undefined
        };

    }
}

export default CreateFacilityTypeReq;